import { Component } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';

@Component({
  selector: 'app-tasking-layout',
  templateUrl: './tasking-layout.component.html',
  styleUrls: ['./tasking-layout.component.less', '../../styles.less'],
  standalone: false,
})
export class TaskingLayoutComponent {
  public SidebarSplitViewKey = SidebarSplitViewKey;
  protected readonly app = Application.tasking;
}
